import {Col, Container, Row} from 'react-bootstrap';

const FooterWithSocialIcons = () => {
    return (
        <Container fluid className="mb-4">
            <Row>
                <Col>
                    <p className="mb-1">© FFEM. 2022.</p>
                </Col>
            </Row>
            <Row>
                <Col>
                    <span className="mb-1">Situe au lieudit *carrefour la vie continue* NGONA 200m de la route principale | </span>
                    <span className="mb-1">Tel : 675 51 88 55 / 699 90 93 21 / 691 77 45 65 | </span>
                    <span className="mb-1">Email : FFEM@gmail.com</span>
                </Col>
            </Row>
        </Container>
    );
};

export default FooterWithSocialIcons;
